import React from 'react'

import Links from '../../constants'
import { DlVector1, DlVector2, DlVector3, DlVector4, DlVector5 } from '../../../../assets/svgs/landingV2/guest'
import { HGooglePlayButton, HAppStoreButton } from '../../../../assets/svgs/landingV2/guest'
import './styles.scss'
import './responsiveStyles.scss'

function Download() {
  return (
    <div className='gl_dl'>
      <img className='gl_dl__vector_1' src={DlVector1} alt='Vector 1' />
      <img className='gl_dl__vector_2' src={DlVector2} alt='Vector 2' />
      <img className='gl_dl__vector_3' src={DlVector3} alt='Vector 3' />
      <img className='gl_dl__vector_4' src={DlVector4} alt='Vector 4' />
      <img className='gl_dl__vector_5' src={DlVector5} alt='Vector 5' />
      <div className='gl_dl__container'>
        <div className='gl_dl__title'>
          <h1>Завантажуй застосунок безкоштовно</h1>
        </div>
        <div className='gl_dl__buttons'>
          <a href={Links.linkToGooglePlay}>
            <img src={HGooglePlayButton} alt='Google play' />
          </a>
          <a href={Links.linkToAppStore}>
            <img src={HAppStoreButton} alt='App store' />
          </a>
        </div>
      </div>
    </div>
  )
}

export default Download
